import { Link } from 'react-router-dom';
import { getFeaturedComics } from '@/mocks/comics';
import ComicCard from '@/components/feature/ComicCard';

export default function FeaturedSection() {
  const featuredComics = getFeaturedComics();

  return (
    <section className="py-12 md:py-16 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-950">
              精选<strong className="text-primary-500">推荐</strong>
            </h2>
            <p className="mt-1 text-sm text-foreground-500">编辑精选优质韩漫作品</p>
          </div>
          <Link
            to="/category/all"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            查看全部 <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
          </Link>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-5">
          {featuredComics.map((comic) => (
            <ComicCard key={comic.id} comic={comic} />
          ))}
        </div>
        <div className="mt-6 text-center sm:hidden">
          <Link
            to="/category/all"
            className="inline-flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            查看全部漫画 <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}